export default "__VITE_ASSET__CSxJpUhU__"